<form *ngIf="form" [formGroup]="form" (ngSubmit)="createEntity()">
    <dx-lookup [gsResource]="featuresRes" formControlName="technicalFeatureId" displayExpr="name" valueExpr="id" formField
        required [label]="'menu.breadcrumb.technicalFeatures' | translate | ucfirst" [createComponent]="createTechnicalFeatureComponent"></dx-lookup>
</form>